


















import {Component, Vue, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import {PriceListStore} from "@/modules/pricelists/store";
import debounce from "lodash/debounce";
import {PriceListParams} from "@/modules/pricelists/params";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";

@Component({
    name: "PriceListSearch",
    components: {PostOfficeSelector, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    CommonStatus = CommonStatus;
    params = new PriceListParams();

    @Watch('params', { immediate: false, deep: true })
    onValuesChange(val: any) {
        this.handleChange(val);
    }

    handleChange = debounce(function (val) {
        PriceListStore.updatePriceListParams(val);
        PriceListStore.listPriceList({ params: {...val, page: 1} })
    }, 500);
}
